type Env = { NODE_ENV?: string; REACT_APP_STYLE_GUIDE?: string };

/**
 * Whether the style guide (/design, src/pages/DesignPage.tsx) is served: in
 * development, and in the builds `just screenshots` makes for its captures
 * (REACT_APP_STYLE_GUIDE=1), but not in the one deployed.
 */
export const styleGuideOn = (env: Env = process.env): boolean =>
  env.NODE_ENV !== "production" || env.REACT_APP_STYLE_GUIDE === "1";
